module.exports = __webpack_public_path__ + "static/media/sound-music-audio-svgrepo-com.29cce498.svg";